<div
  [style.border]="itemStyle().card.border"
  [style.boxShadow]="itemStyle().card.boxShadow"
  [style.background]="itemStyle().card.background"
  [style.borderRadius]="itemStyle().card.borderRadius"
  class="card {{ dataService.environment().retailerName }} {{
    dataService.currentPage()
  }} "
>
  <img
    class="step-img"
    [src]="stepContent().picture.imageUrl"
    [alt]="stepContent().picture.alternativeText"
  />
  <p
    class="card-body"
    [style.color]="itemStyle().description.color"
    [style.fontFamily]="itemStyle().description.fontFamily"
    [innerHTML]="
      stepContent().description
        | replaceVars
          : environment.maxSelectedChallenges
          : false
          : '{maxSelectedChallenge}'
        | safe
    "
  ></p>
</div>
